import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  useCreateServiceDataMutation,
  useDeleteServiceTypeInfoMutation,
  useGetAllServiceDataQuery,
} from "../../../Services/vehicle/Vehicle";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import EditServiceModal from "./EditServiceModal";
import useThemeColors from "../ThemeColors";
import DeleteModal from "../DeleteModal";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";

interface IPROPS {
  setLiftingName: any;
}

const ITEMS_PER_PAGE = 20;

const Service: React.FC<IPROPS> = ({ setLiftingName }) => {
  const [serviceName, setServiceName] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [serviceTableData, setServiceTableData] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [storedData, setStoredData] = useState();
  const [image, setImage] = useState<any>("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalCount] = useState(0);
  const [tableLoader, setTableLoader] = useState(false);
  const [uploadButonClicked, setUploadButtonClicked] = useState(false);
  const [icon, setIcon] = useState(null);
  const [uploadIconClicked, setUploadIconClicked] = useState(false);

  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);

  const [deleteTrigger] = useDeleteServiceTypeInfoMutation();

  const name = "Service Information";

  useEffect(() => {
    setLiftingName(name);
  }, [setLiftingName]);

  const [createServiceTrigger] = useCreateServiceDataMutation();

  const {
    data: serviceData,
    status,
    refetch,
    isLoading,
  } = useGetAllServiceDataQuery({
    page: currentPage,
    page_size: ITEMS_PER_PAGE
  });

  useEffect(() => {
    if (serviceData) {
      setServiceTableData(serviceData?.results);
      setTotalCount(serviceData?.count || 0);
    }
  }, [serviceData]);

  useEffect(() => {
    if (status === "pending") {
      setTableLoader(true);
    } else {
      setTableLoader(false);
    }
  }, [status]);

  const createVehicleDataHandler = async () => {
    const formData = new FormData();
    formData.append("name", serviceName);
    if (image) formData.append("image", image);
    if (icon) formData.append("icon", icon);

    try {
      await createServiceTrigger(formData).unwrap(); // unwrap = clean success/error
      toast.success("Data added successfully");
      refetch();
      setServiceName("");
      setSubCategory("");
      setImage(null);
      setIcon(null);
      setUploadButtonClicked(false);
      setUploadIconClicked(false);
    } catch (error: any) {
      const apiError = error?.data;
      if (apiError?.non_field_errors?.length) {
        toast.error(apiError.non_field_errors[0]);
      } else if (apiError?.name?.length) {
        toast.error(apiError.name[0]);
      } else {
        toast.error("An unexpected error occurred");
      }
      console.error("Create API Error:", error);
    }
  };

  const editHandler = (vehicle) => {
    setOpenEditModal(true);
    setStoredData(vehicle);
  };

  const closeModal = () => {
    setOpenEditModal(false);
    setOpenDeleteModal(false);
  };

  const deleteHandler = (vehicle) => {
    setStoredData(vehicle);
    setOpenDeleteModal(true);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };

  const { selectedButtonBackgoundColors, selectedButtonColors } =
    useThemeColors();

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // Ideally trigger a data fetch here if paginated server-side
    }
  };

  const imageHandler = (e) => {
    setUploadButtonClicked(true);
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const iconHandler = (e) => {
    setUploadIconClicked(true);
    const file = e.target.files[0];
    if (file) {
      setIcon(file);
    }
  };

  return (
    <div className="vehicle-info-cont">
      <div className="workshops-container">
        <div className="vehicle-info-middle">
          <div
            className="vehicle-info-middle-heading"
            style={{
              fontFamily: "Karbon-medium",
              fontSize: "20px",
            }}
          >
            Add Service Type
          </div>
          <div
            className="vehicle-info"
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <div>
              <p className="vehicle-class">
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    marginTop: "10px",
                    fontSize: "20px",
                    fontFamily: "Karbon-medium",
                  }}
                >
                  Service
                </span>
                <span>
                  <input
                    value={serviceName}
                    style={{ borderRadius: "20px", background: "#FCFCFC" }}
                    placeholder="Add Service"
                    className="form-control"
                    type="text"
                    onChange={(e) => {
                      const alphaValue = e.target.value.replace(
                        /[^a-zA-Z ]/g,
                        ""
                      );
                      setServiceName(alphaValue);
                    }}
                  />
                </span>
              </p>
            </div>
            {/* Image */}

            <div>
              <p>
                <label
                  htmlFor="upload-logo"
                  style={{
                    background: `${selectedButtonBackgoundColors}`,
                    color: `${selectedButtonColors}`,
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "20px",
                    fontSize: "15px",
                    cursor: "pointer",
                    fontFamily: "Karbon-medium",
                  }}
                >
                  Upload Image
                </label>
                {uploadButonClicked ? (
                  <div
                    style={{
                      border: "1px solid black",
                      borderStyle: "dotted",
                      height: "200px",
                      width: "200px",
                    }}
                  >
                    {image && (
                      <img
                        src={URL.createObjectURL(image)}
                        alt="preview"
                        width={200}
                        height={200}
                      />
                    )}
                  </div>
                ) : (
                  ""
                )}

                <input
                  type="file"
                  id="upload-logo"
                  style={{ display: "none" }}
                  onChange={imageHandler}
                />
              </p>
            </div>

            <div>
              <p>
                <label
                  htmlFor="upload-icon"
                  style={{
                    background: selectedButtonBackgoundColors,
                    color: selectedButtonColors,
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "20px",
                    fontSize: "15px",
                    cursor: "pointer",
                    fontFamily: "Karbon-medium",
                  }}
                >
                  Upload Icon
                </label>
                {uploadIconClicked && (
                  <div
                    style={{
                      border: "1px solid black",
                      borderStyle: "dotted",
                      height: "100px",
                      width: "100px",
                    }}
                  >
                    {icon && (
                      <img
                        src={URL.createObjectURL(icon)}
                        alt="icon preview"
                        width={100}
                        height={100}
                      />
                    )}
                  </div>
                )}

                <input
                  type="file"
                  id="upload-icon"
                  style={{ display: "none" }}
                  onChange={iconHandler}
                />
              </p>
            </div>

            {/* Image end */}
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                disabled={!serviceName.trim()}
                onClick={createVehicleDataHandler}
                style={{
                  background: !serviceName.trim()
                    ? "#F7D3C5"
                    : `${selectedButtonBackgoundColors}`,
                  color: `${selectedButtonColors}`,
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "20px",
                  fontSize: "15px",
                  cursor: !serviceName.trim() ? "not-allowed" : "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <div className="vehicle-info-bottom mt-10">
          <div className="vehicle-info-bottom-heading">Service Types</div>
          <table className="vehicle-info-bottom-table">
            <thead className="thead">
              <tr className="tr">
                <td>Sr.No.</td>
                <td>Service</td>
                {/* <td>Sub category</td> */}
                <td style={{ padding: "0 10px" }}>Action</td>
              </tr>
            </thead>
            <tbody className="table-body">
              {serviceTableData?.map((service, index) => (
                <tr
                  className="table-body-tr"
                  style={{ background: index % 2 !== 0 ? "#FFF1EC" : "white" }}
                >
                  <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                  <td style={{ paddingLeft: "40px" }}>
                    {capitalizeFirstLetter(service?.name)}
                  </td>
                  {/* <td>{service?.sub_service_type}</td> */}
                  <td
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span onClick={() => editHandler(service)}>
                      <i
                        className="bi bi-pencil"
                        style={{ fontSize: "20px", cursor: "pointer" }}
                      ></i>
                    </span>
                    {/* <span onClick={() => deleteHandler(service)}>
                      <i
                        className="bi bi-trash3"
                        style={{ fontSize: "20px", cursor: "pointer" }}
                      ></i>
                    </span> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination-footer mb-10">
          <div className="pagination-info">
            Showing {startIndex + 1} - {endIndex} of {totalItems}
          </div>

          <div className="pagination-controls">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-btn"
            >
              Prev
            </button>

            {/* Always show exactly 5 page numbers, centered around current page */}
            {Array.from(
              { length: Math.min(5, totalPages) },
              (_, i) => {
                // Calculate the first page to show (ensuring we always show 5 if possible)
                let firstPage = Math.max(1, Math.min(
                  currentPage - 2,  // Try to center current page
                  totalPages - 4    // But don't go past total pages - 4
                ));

                const pageNum = firstPage + i;

                return (
                  <button
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={`pagination-btn ${pageNum === currentPage ? 'active' : ''}`}
                    style={{
                      display: pageNum > totalPages ? 'none' : 'inline-block',
                      margin: '0 2px',
                      minWidth: '32px',
                      textAlign: 'center'
                    }}
                  >
                    {pageNum}
                  </button>
                );
              }
            )}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      <Modal
        open={openEditModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <EditServiceModal
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
            />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openDeleteModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <DeleteModal
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
              trigger={deleteTrigger}
              setTableData={setServiceTableData}
              fieldsData={serviceTableData}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Service;
